import React, { createContext, useContext, useState } from 'react';
const MegaMenuContext = createContext(undefined);
export const useMegaMenu = () => useContext(MegaMenuContext);
export const MegaMenuProvider = ({ children }) => {
    /**
     * Used to track the menu state on mobile
     */
    const [menuActive, setMenuActive] = useState(false);
    /**
     * The state of the flyout
     */
    const [flyoutActive, setFlyoutActive] = useState(false);
    // The active flyout index
    const [activeFlyoutIndex, setActiveFlyoutIndex] = useState(null);
    const [mainMenuItems, setMainMenuItems] = useState([]);
    const [flyoutItems, setFlyoutItems] = useState([]);
    const [restoreElement, setRestoreElement] = useState(null);
    const [elementAfterFlyout, setElementAfterFlyout] = useState(null);
    const [flyoutHasFocus, setFlyoutHasFocus] = useState(false);
    const [megaMenuVariant, setMegaMenuVariant] = useState(undefined);
    return (React.createElement(MegaMenuContext.Provider, { value: {
            menuActive,
            setMenuActive,
            flyoutActive,
            setFlyoutActive,
            activeFlyoutIndex,
            setActiveFlyoutIndex,
            mainMenuItems,
            setMainMenuItems,
            flyoutItems,
            setFlyoutItems,
            restoreElement,
            setRestoreElement,
            flyoutHasFocus,
            setFlyoutHasFocus,
            elementAfterFlyout,
            setElementAfterFlyout,
            megaMenuVariant,
            setMegaMenuVariant,
        } }, children));
};
